import { routesGuest } from '../../../consts'
import type { LegalDocumentSlug } from './types'

export const legalDocumentPaths: Record<LegalDocumentSlug, string> = {
  rules: routesGuest.RULES.path,
  privacy: routesGuest.PRIVACY.path,
  cookies: routesGuest.COOKIES.path,
}

export function getLegalDocumentPath(slug: LegalDocumentSlug): string {
  return `/${legalDocumentPaths[slug]}`
}
